import "bootstrap-switch";
import $ from "jquery";

$.fn.bootstrapSwitch.defaults = {
  state: true,
  size: null,
  animate: true,
  disabled: false,
  readonly: false,
  indeterminate: false,
  inverse: false,
  radioAllOff: false,
  onColor: 'primary',
  offColor: 'default',
  onText: '',
  offText: '',
  labelText: '',
  handleWidth: 'auto',
  labelWidth: 'auto',
  baseClass: 'toggle-switch',
  wrapperClass: '',
  onInit: function() {},
  onSwitchChange: function() {}
};
